// 跳转登录页面
export const gotoSignIn = () => {
  const url = encodeURIComponent(window.location.pathname + window.location.hash);
  window.location.href = `//${window.location.host}/signin?next=${url}`;
};